import api from '../../components/api'
import { CalendarEvent } from './calendarEvent'

export const getCalendarEventsForJob = async (jobId: number): Promise<CalendarEvent[]> => {
  const response = await api.get(`/web/calendar-events/job/${jobId}`)
  return response.data as CalendarEvent[]
}
